import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { InvoiceService } from 'projects/Administration/src/app/business-services/invoice.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { CookieService } from 'ngx-cookie-service';
import { CultureLocaleService } from 'projects/Administration/src/app/services/culture-locale.service';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { PostedInvoiceList} from 'projects/Administration/src/app/business-entities/invoice-model';
import { EditAppointmentService } from 'projects/Administration/src/app/business-services/edit-appointment.service';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import * as saveAs from 'file-saver';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { UserDataService } from 'src/app/DataServices/user-data.service';

@Component({
  selector: 'app-appointment-invoice',
  templateUrl: './appointment-invoice.component.html',
  styleUrls: ['./appointment-invoice.component.css']
})
export class AppointmentInvoiceComponent implements OnInit {
  postedInvoiceList: PostedInvoiceList[];
  totalCount: number = 0;
  isInvoiceComplete:string = "No";
  pdfUrl: string | undefined;
  trustedBlobUrl: SafeResourceUrl;
  isDownloadVisible = false;

  constructor(private activeModal: NgbActiveModal,
    public editAppointmentService: EditAppointmentService,
    private globalSetting: GlobalSetting,
    private service: InvoiceService,
    private toaster: ToastrService,
    private translate: TranslateService,
    private spinner: NgxSpinnerService,
    private cookieservice: CookieService,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private userService: UserDataService,
    public cultureLocaleService: CultureLocaleService) { }

  ngOnInit(): void {
    this.postedInvoiceList = [];
    this.isDownloadVisible = this.userService?.currentUserValue?.userRoleMenuDetails?.find(x=>x.moduleId === Enums.ModuleNames.AllowInvoiceDownload)?.canView;
    this.GetPostedInvoiceList();
  }
 async GetPostedInvoiceList() {
    this.spinner.show();
    this.totalCount = 0;
    this.isInvoiceComplete = "No";
    let LanguageCode = this.cookieservice.get('userSelectedLanguage');
    let id = this.editAppointmentService.appointmentDetails.id;
    let wo = this.editAppointmentService.appointmentDetails.workOrderNo;
    await this.service.getPostedInvoiceByWo(id, wo).then((response) => {
      this.spinner.hide();
      if (response.responseCode === Constant.SuccessResponseCode) {
        if (response.responseObject.isSuccess) {
          this.postedInvoiceList = response.responseObject.postedInvoiceList;
          this.totalCount = this.postedInvoiceList != null ? this.postedInvoiceList.length : 0;
          this.isInvoiceComplete = response.responseObject.isComplete?"Yes":"No";
        }
        else {
          // this.toaster.error(response.responseObject.resultMessage);
          // this.spinner.hide();
        }
      }
    },
      _error => {
        this.spinner.hide();
      });
  }
  ngOnDestroy(): void {
    this.postedInvoiceList = [];
    this.totalCount = 0;
    this.isInvoiceComplete = "No";
  }

  getLocalDate(date){
    return new Date(date+"Z");
  }

  OnClose() {
    this.activeModal.close({success: false});
  }

  async onDownload(invoiceNo : string, isPreview = false, previewModal = null){
    this.spinner.show();
    let LanguageCode = this.cookieservice.get('userSelectedLanguage');
    await this.service.getInvoiceDocument(invoiceNo, LanguageCode).then((response) => {
      this.spinner.hide();
      if (response.responseCode === Constant.SuccessResponseCode) {
        if (isPreview) {
          this.onPreview(previewModal, response.responseObject.fileContents);
        } else {
          let blob = Utility.base64toBlob(response.responseObject.fileContents, "application/pdf;charset=utf-8");
          saveAs(blob, response.responseObject.fileDownloadName);
        }
      } else {
        this.toaster.error(response.responseMessage);
        this.spinner.hide();
      }
    },
      _error => {
        this.spinner.hide();
      });
  }

  async onPreview(content, base64String: string) {
    if (base64String) {
      let blob = Utility.base64toBlob(base64String, "application/pdf;charset=utf-8");
      this.pdfUrl = URL.createObjectURL(blob);
      this.trustedBlobUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.pdfUrl+'#toolbar=0');

      this.modalService
      .open(content, { ariaLabelledBy: 'modal-basic-title', size: 'lg' })
      .result;
    }
  }

}
